import { select } from 'd3-selection'
import { addOldFilesToHTMLList } from './add-to-html-list/addOldFilesToHTMLList'
import { uploadFile } from './uploadFile'
import { appendModal } from './appendModal'

export let initUploadFiles = () => {
  appendModal()
  addOldFilesToHTMLList()
  select('#fileInput')
    .on('change', () => {
      let fileList = getFileList()
      for (let i = 0; i < fileList.length; ++i) {
        uploadFile(fileList[i])
      }
      eraseFilesFromInput()
    })
}

function getFileList () {
  /** @type {HTMLInputElement} */
  // @ts-ignore
  let fileInput = document.getElementById('fileInput')
  return fileInput.files
}

function eraseFilesFromInput(){
  document.getElementById('fileInput').value = "";
}